<div class="top">
    <div class="Frame-3">
        <img src="assets\Images\Frame 3 (2) 1.png" height="900" width="100%" class="responsive">
    </div>
    <div>
        <h3 class="text-center" style="margin-top: 40px;margin-bottom: 60px;">Wondering what can we buy from India?
            Almost everything!!!</h3>
    </div>
</div>